var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-reports-container"},[_c('MySavedReports',{attrs:{"rows":_vm.rows,"scheduled-reports":_vm.scheduledReports,"loading":_vm.isDataLoading,"error":_vm.errorMessage},on:{"update-data-loading":_vm.updateDataLoading,"refresh-saved-reports":_vm.getUpdateSavedReports}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }